function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var VDS = window.WinBoostAiDesignSystem_0f78b0;
var VAccordion = VDS.Accordion;
var VOICE_FAQ = [{
  q: 'How does the WinBoost AI Phone understand what callers say?',
  a: 'It listens to the caller in real time and turns their words into text, then works out what they need: a booking, a price, an answer about your service. Its answers come from the knowledge you give it during onboarding, so it talks about your business, not in generalities.'
}, {
  q: 'Does it sound like a robot?',
  a: 'No. Every reply is spoken in a natural human voice, with the pauses, pacing and tone of a real conversation. It handles interruptions, understands accents and remembers what was already said, so most callers simply book, ask their question or get transferred without noticing anything unusual. It can even speak in the voice of someone on your team.'
}, {
  q: "Can WinBoost AI clone a team member\u2019s voice?",
  a: "Yes, with that person\u2019s consent. They record a short voice sample, and your AI Phone learns their tone and warmth. From then on, every call it answers or makes sounds like someone your customers already know."
}, {
  q: "Is my team member\u2019s cloned voice kept private?",
  a: "Yes. A cloned voice is only ever used for your own business\u2019s calls. It is never shared or used anywhere else, and it can be removed at any time on request."
}, {
  q: 'Can it handle interruptions and follow-up questions?',
  a: 'Yes. It keeps listening while it speaks. If a caller cuts in or changes their mind, it stops, takes in what they said and carries on from there, the way a person would.'
}, {
  q: 'How does it book appointments into my calendar?',
  a: 'It connects to your calendar and checks open slots live while the caller is on the line. Once the caller picks a time it books it, sends an SMS confirmation straight away, then reminds them 24h and 2h before the appointment.'
},, {
  q: 'Which technology does WinBoost use?',
  a: "Your AI Phone runs on WinBoost\u2019s own combination of speech, language and voice technology, tuned specifically for phone calls. What matters to you is the result: it listens, understands and answers like your best receptionist, on every call."
}];
function VBars(_ref) {
  var gold = _ref.gold,
    _ref$n = _ref.n,
    n = _ref$n === void 0 ? 22 : _ref$n;
  var H = [10, 18, 26, 14, 30, 20, 12, 24, 32, 16, 22, 28, 12, 20, 10, 18, 26, 12, 22, 16, 28, 14];
  return React.createElement("span", {
    "aria-hidden": "true",
    style: {
      display: 'flex',
      alignItems: 'center',
      gap: 3,
      height: 34
    }
  }, H.slice(0, n).map(function (h, i) {
    return React.createElement("span", {
      key: i,
      style: {
        width: 3,
        height: h,
        borderRadius: 2,
        background: gold ? 'linear-gradient(0deg,#FFAE06,#FC6306)' : 'var(--ink-300)'
      }
    });
  }));
}
function VoiceHow() {
  var stages = [{
    n: '01',
    t: 'The caller speaks',
    d: 'A customer calls, any hour of the day.',
    tag: 'Live call',
    v: React.createElement(VBars, {
      n: 14
    })
  }, {
    n: '02',
    t: 'It listens',
    d: 'Their words turn into text as they talk.',
    tag: 'Speech to text',
    v: React.createElement("span", {
      style: {
        padding: '6px 10px',
        borderRadius: '12px 12px 12px 3px',
        background: 'var(--sand-100)',
        fontSize: 12,
        fontWeight: 700,
        lineHeight: 1.3,
        color: 'var(--text-primary)'
      }
    }, "\u201CCan I book a cleaning for Thursday?\u201D")
  }, {
    n: '03',
    t: 'It understands',
    d: 'It works out what they need and checks your calendar.',
    tag: 'Understanding',
    v: React.createElement("span", {
      style: {
        display: 'flex',
        alignItems: 'center',
        gap: 8
      }
    }, React.createElement("img", {
      src: A + 'orbit.png',
      alt: "",
      style: {
        width: 30,
        height: 30,
        display: 'block'
      }
    }), React.createElement("span", {
      style: {
        display: 'flex',
        flexDirection: 'column',
        gap: 4
      }
    }, React.createElement("span", {
      style: {
        fontSize: 11,
        fontWeight: 800,
        padding: '3px 8px',
        borderRadius: 999,
        background: 'var(--grad-brand-soft)',
        color: 'var(--text-primary)',
        whiteSpace: 'nowrap'
      }
    }, "Wants: booking"), React.createElement("span", {
      style: {
        fontSize: 11,
        fontWeight: 800,
        padding: '3px 8px',
        borderRadius: 999,
        background: 'var(--grad-brand-soft)',
        color: 'var(--text-primary)',
        whiteSpace: 'nowrap'
      }
    }, "Thu 10:30 free")))
  }, {
    n: '04',
    t: "It replies in your team\u2019s voice",
    d: 'A natural answer, spoken the way your team speaks.',
    tag: 'Text to speech',
    v: React.createElement("span", {
      style: {
        display: 'flex',
        alignItems: 'center',
        gap: 8
      }
    }, React.createElement(VBars, {
      gold: true,
      n: 9
    }), React.createElement("span", {
      style: {
        fontSize: 11,
        fontWeight: 800,
        padding: '4px 9px',
        borderRadius: 999,
        background: 'var(--wb-orange)',
        color: 'var(--wb-white)',
        whiteSpace: 'nowrap'
      }
    }, "Sarah\u2019s voice"))
  }];
  return React.createElement(Section, {
    id: "how-it-talks",
    style: {
      background: 'var(--wb-white)',
      borderTop: '1px solid var(--border-hairline)',
      borderBottom: '1px solid var(--border-hairline)'
    }
  }, React.createElement(Head, {
    label: "How it talks",
    title: "How your AI Phone Lead Closer holds a real conversation.",
    lead: "Every caller gets a real back-and-forth, not a menu. Here is what happens each time they speak."
  }), React.createElement("div", {
    className: "vx-grid"
  }, React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 14,
      minWidth: 0
    }
  }, React.createElement("div", {
    style: {
      border: '1px solid var(--border-card)',
      borderRadius: 'var(--radius-lg)',
      background: 'var(--wb-white)',
      overflow: 'hidden'
    }
  }, stages.map(function (s, i) {
    return React.createElement("div", {
      key: s.n,
      className: "vx-row",
      style: {
        borderTop: i ? '1px solid var(--border-hairline)' : 'none',
        background: i === 3 ? 'var(--grad-brand-soft)' : 'transparent'
      }
    }, React.createElement("span", {
      style: {
        fontSize: 12,
        fontWeight: 800,
        letterSpacing: '.1em',
        color: 'var(--wb-orange)'
      }
    }, s.n), React.createElement("div", {
      style: {
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        minWidth: 0
      }
    }, React.createElement("span", {
      style: {
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        flexWrap: 'wrap'
      }
    }, React.createElement("span", {
      style: {
        fontSize: 15,
        fontWeight: 800,
        lineHeight: 1.25,
        color: 'var(--text-primary)'
      }
    }, s.t), React.createElement("span", {
      style: {
        fontSize: 10,
        fontWeight: 800,
        letterSpacing: '.08em',
        textTransform: 'uppercase',
        color: 'var(--ink-500)',
        padding: '2px 7px',
        border: '1px solid var(--border-hairline)',
        borderRadius: 999,
        background: 'var(--wb-white)'
      }
    }, s.tag)), React.createElement("span", {
      style: {
        fontSize: 13.5,
        lineHeight: 1.4,
        color: 'var(--text-secondary)'
      }
    }, s.d)), React.createElement("div", {
      className: "vx-vis"
    }, s.v));
  })), React.createElement("div", {
    style: {
      position: 'relative',
      overflow: 'hidden',
      border: '1.5px solid var(--wb-orange)',
      borderRadius: 'var(--radius-lg)',
      background: 'var(--wb-white)',
      padding: '18px 18px 16px',
      display: 'flex',
      flexDirection: 'column',
      gap: 12,
      boxShadow: '0 12px 30px rgba(23,23,23,.07)'
    }
  }, React.createElement("span", {
    "aria-hidden": "true",
    style: {
      position: 'absolute',
      inset: '0 0 auto',
      height: 4,
      background: 'linear-gradient(90deg,#FFAE06,#FC6306)'
    }
  }), React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 5
    }
  }, React.createElement("span", {
    className: "wb-label",
    style: {
      color: 'var(--wb-orange)'
    }
  }, "Voice cloning \xB7 with consent"), React.createElement("span", {
    style: {
      fontSize: 20,
      fontWeight: 800,
      letterSpacing: '-.02em',
      lineHeight: 1.2,
      color: 'var(--text-primary)'
    }
  }, "Callers hear someone they already know."), React.createElement("span", {
    style: {
      fontSize: 14,
      lineHeight: 1.5,
      color: 'var(--text-secondary)'
    }
  }, "With their permission, WinBoost AI can clone a team member\u2019s voice. Every call your AI Phone answers or makes then sounds like your own team, and leads land in your calendar.")), React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: 'minmax(0,1fr) auto minmax(0,1fr) auto minmax(0,1fr)',
      alignItems: 'start',
      gap: 6
    }
  }, [['mic', 'Record a sample', 'A team member says yes'], ['orbit', 'AI learns the voice', 'Same tone, same warmth'], ['cal', 'Leads get booked', 'Leads in your calendar']].flatMap(function (_ref2, i) {
    var _ref3 = _slicedToArray(_ref2, 3),
      k = _ref3[0],
      t = _ref3[1],
      s = _ref3[2];
    var icon = k === 'orbit' ? React.createElement("img", {
      src: A + 'orbit.png',
      alt: "",
      style: {
        width: 26,
        height: 26,
        display: 'block'
      }
    }) : React.createElement("svg", {
      width: "18",
      height: "18",
      viewBox: "0 0 24 24",
      fill: "none",
      "aria-hidden": "true"
    }, React.createElement("path", {
      d: k === 'mic' ? 'M12 15a3.5 3.5 0 0 0 3.5-3.5v-6a3.5 3.5 0 1 0-7 0v6A3.5 3.5 0 0 0 12 15ZM5 11.5a7 7 0 0 0 14 0M12 15v6.5M8.5 21.5h7' : 'M4 6.5h16v14H4zM4 10.5h16M8.5 3v4M15.5 3v4M8 14.5l2.5 2.5 5-5',
      stroke: "var(--wb-orange)",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }));
    var step = React.createElement("div", {
      key: k,
      style: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        gap: 5,
        minWidth: 0
      }
    }, React.createElement("span", {
      style: {
        width: 44,
        height: 44,
        borderRadius: '50%',
        background: 'var(--grad-brand-soft)',
        border: '1px solid rgba(252,99,6,.25)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }
    }, icon), React.createElement("span", {
      style: {
        fontSize: 13,
        fontWeight: 800,
        lineHeight: 1.2,
        color: 'var(--text-primary)'
      }
    }, t), React.createElement("span", {
      style: {
        fontSize: 12,
        fontWeight: 600,
        lineHeight: 1.3,
        color: 'var(--text-secondary)'
      }
    }, s));
    return i < 2 ? [step, React.createElement("span", {
      key: k + '-a',
      "aria-hidden": "true",
      style: {
        marginTop: 12,
        color: 'var(--wb-orange)',
        fontSize: 16,
        fontWeight: 800
      }
    }, "\u2192")] : [step];
  })))), React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 12,
      minWidth: 0
    }
  }, React.createElement("span", {
    className: "wb-label",
    style: {
      color: 'var(--wb-orange)'
    }
  }, "Questions about how it works"), React.createElement("div", {
    style: {
      fontSize: 14
    }
  }, React.createElement(VAccordion, {
    items: VOICE_FAQ
  })))), React.createElement("script", {
    type: "application/ld+json",
    dangerouslySetInnerHTML: {
      __html: JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: VOICE_FAQ.map(function (f) {
          return {
            '@type': 'Question',
            name: f.q,
            acceptedAnswer: {
              '@type': 'Answer',
              text: f.a
            }
          };
        })
      })
    }
  }), React.createElement("style", null, '.vx-grid{display:grid;grid-template-columns:minmax(0,1.05fr) minmax(0,1fr);gap:clamp(20px,3vw,44px);align-items:start}.vx-row{display:grid;grid-template-columns:24px minmax(0,1fr) auto;gap:12px;align-items:center;padding:12px 16px}.vx-vis{display:flex;justify-content:flex-end;min-width:0;max-width:210px}@media(max-width:1000px){.vx-grid{grid-template-columns:minmax(0,1fr)}}@media(max-width:620px){.vx-row{grid-template-columns:24px minmax(0,1fr)}.vx-vis{grid-column:2;justify-content:flex-start}}'));
}
Object.assign(window, {
  VoiceHow: VoiceHow
});